module.exports = __webpack_public_path__ + "img/icon-white-51.7e7f89af.svg";